<template>
<!-- 档案借阅 -->
  <div class="detail">
    <ax-panel title="基本信息">
      <van-cell title="原件/复印件" >
      {{data.header.qh_jy_type === 'B'?'原件' : '复印件'}}
      </van-cell>
      <van-cell title="借阅类型" :value="group_select_instr"></van-cell>
      <van-cell v-if="data.header.qh_jy_type == 'B'" title="邮寄地址" :value="data.header.qh_mail_address_description"></van-cell>
      <van-cell title="借阅原因" :value="data.header.comments"></van-cell>
      <van-cell title="附件" v-if="data.header.wf_status === 'A' && data.header.qh_jy_type === 'A'">
         <div class="ax-down-box" @click="getFileData()">
          <div class="item_content_name">
            <div class="label_box blue">查看</div>
          </div>
          <van-icon class-prefix="iconfont" name="down"   /> 
        </div>
      </van-cell>
    </ax-panel>
    <!-- <ax-panel title="申请人信息">
      <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
      <van-cell title="电话">
        <a class="link_a" :href="'tel:'+data.header.emplid_phone">{{data.header.emplid_phone}}</a>
      </van-cell>
      <van-cell title="部门" :value="data.header.deptid_description"></van-cell>
    </ax-panel> -->
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  props: ['data'],
  data(){
    return {
      toast: null,
      list : [],
      time: 5,
      addressTime: 5,
      group_select_instr:'',
      qh_mail_address: ''
    }
  },
  created(){
    this.getTypeByCode();
    // this.getAddressDetail()
  },
  methods: {
    // 点击查看附件 直接提示
    getFileData(){
      this.$toast('请前往PC端查看附件！')
    },
    // 获取 借阅类型
    getTypeByCode(){
      let options = {
        url: '/treasure/ehr/archivesBorrowing/DoArchiveTypeListH5',
        method: 'POST',
        data: {
          emplid: this.data.header.emplid, // 员工编号
          action_dt_ss: this.data.header.action_dt_ss, // 提交时间
          effseq: this.data.header.effseq, // 生效序号
        }
      }
      request(options).then( ({data}) => {
        if(data.code == 200){
          this.list = data.data || [];
          this.getNameByCode();
        }
      }).catch(_ => {
      })
    },
    // 获取地址信息
    getAddressDetail(){
       let options = {
        url: '/treasure/ehr/archivesBorrowing/DoGetAddressList',
        method: 'POST'
      }
      request(options).then( ({data}) => {
        if(data.code == 200 && data.data){
          let dd = data.data.find(subItem => ~this.data.header.qh_mail_address == subItem.value);
          if(dd){
            this.qh_mail_address = dd.description;
          }
        }
      }).catch(_ => {
      })
    },
    getNameByCode(){
      if(!this.data.header.group_select_instr || !this.list.length){
        this.group_select_instr = this.data.header.group_select_instr;
        this.time -= 1;
        if(this.time < 0){
          return false;
        }
        setTimeout(() => {
          this.getNameByCode();
        }, 1000)
      }
      let codeList = [], codeName = [];
      codeList = this.list.reduce( (ddList, item) => {
        // console.log(ddList);
        item.sub_type.forEach(dd => {
          ddList.push(dd);
        })
        return ddList;
      }, []);
      let code = this.data.header.group_select_instr.split(',');
      code.forEach(cItem => {
        let dd = codeList.find(subItem => ~cItem.indexOf(subItem.sub_code));
        if(dd){
          codeName.push(dd.sub_name);
        }
      })
      this.group_select_instr = codeName.join(',');
    }
  },
  beforeDestroy() {
      this.toast && this.toast.clear();
    }
}
</script>
<style lang="scss" scoped>
 .ax-down-box{
    line-height: 22px;
    height: 22px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    font-size: 14px;
    color: #999;
    &:not(:first-child){
      line-height: 32px;
      height: 32px;
    }
    .item_content_name{
      -webkit-box-flex: 1;
      -webkit-flex: 1 1 0%;
      flex: 1 1 0%;
      max-width: 200px;
      .label_box{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.blue{
          color: #2FA5FF;
        }
      }
      .brief_box{
        font-size: 12px;
        line-height: 1.4;
      }
    }
    .item_content_val{
      min-height: 22px;
      display: -webkit-inline-box;
      display: -webkit-inline-flex;
      display: inline-flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: end;
      -webkit-justify-content: flex-end;
      justify-content: flex-end;
      word-break: break-all;
      .iconfont{
       color: #ccc;
       font-size: 16px;
      }
    }
  }
</style>